// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"49f25bf7","422":"bfef7f3c","458":"1355b93c","919":"31d6cfe0"}[chunkId] + ".chunk.css";
};